
import Vue from 'vue';
import Component from 'vue-class-component';
import { Emit, Prop, PropSync } from 'vue-property-decorator';
import {
  acceptedModule,
  acceptedState,
  authModule,
  challengesState,
  followedState,
  teamsState,
  userModule,
  userState
} from '@/utils/store-acessor';
import ChallengeDialogAccept from './ChallengeDialogAccept.vue';
import ChallengeDialogNoProfile from './ChallengeDialogNoProfile.vue';
import ChallengeDialogAbort from './ChallengeDialogAbort.vue';
import SignInDialog from '@/components/Auth/SignInDialog.vue';
import PopupAcceptChallenge from '@/components/Popups/PopupAcceptChallenge.vue';
import { UserModel } from '@/models/user.model';
import { TeamModel } from '@/models/team.model';
import { ChallengeModel } from '@/models/challenge.model';
import moment from 'moment-timezone/moment-timezone';

@Component({
  components: {
    ChallengeDialogAccept,
    ChallengeDialogNoProfile,
    ChallengeDialogAbort,
    SignInDialog,
    PopupAcceptChallenge
  }
})
export default class ChallengeActions extends Vue {
  @PropSync('disabled', { required: true, default: false })
  isDisabled!: boolean;
  @Prop({ required: true }) challenge!: ChallengeModel;
  @Prop({ required: true }) teamsEnable!: boolean;
  @Prop({ required: true, default: false }) disableTeam!: boolean;
  @authModule.Getter('isAuthenticated') isAuthenticated!: boolean;
  @userModule.Getter('user') user!: UserModel;
  @userModule.Getter('canAcceptChallenges') userCanAcceptChallenges!: boolean;
  @userModule.Getter('timezone') timezone!: string;
  @acceptedModule.Getter('acceptedChallenges')
  acceptedChallenges!: ChallengeModel[];
  @acceptedModule.Getter('userHasAccepted') userHasAccepted!: (
    challengeId: number
  ) => boolean;
  confirmAcceptDialog: boolean = false;
  confirmNoProfileDialog: boolean = false;
  confirmAbortDialog: boolean = false;
  signInDialog: boolean = false;
  buttonTrigger: boolean = false;

  submitting: boolean = false;
  error: ExceptionInformation | null = null;

  snackbarVisibility: boolean = false;
  snackbarColor: string = 'green';
  snackbarText: string = '';
  myTeam: TeamModel | null = null;

  get showButtons(): boolean {
    return !(this.challenge?.is_advisor || this.challenge?.is_judge || this.challenge?.is_challenge_admin);
  }

  get userHasTeam(): boolean {
    if ((this.challenge?.id) && (this.user?.contestant?.id)) {
      teamsState.fetchMyTeam(this.challenge.id, this.user?.contestant?.id).then((myTeam: TeamModel | null) => {
        this.myTeam = myTeam
        console.log(this.myTeam);
        console.log(myTeam);
        if(myTeam){
          return true;
        }
        return false;
      });
    }
    return false;
  }

  get registrationIsPossible(): boolean {
    if (!this.challenge?.registration_deadline) {
      return true;
    }
    if (this.challenge?.registration_deadline == 'finished') {
      return false
    }
    return moment(this.challenge.registration_deadline).tz(this.timezone).isAfter(moment())
  }

  TogglePopup() {
    this.buttonTrigger = false;
  }

  acceptHandler() {
    if (!this.user) {
      this.signInDialog = true;
      return;
    }

    /**
     * User is registered and does not have
     * completed its profile.
     */
    if (!this.userCanAcceptChallenges) {
      this.confirmNoProfileDialog = true;
      return;
    }

    this.confirmAcceptDialog = true;
  }

  @Emit()
  onChallengeAccepted(): boolean {
    return true;
  }

  async accept() {
    this.confirmAcceptDialog = false;
    try {
      this.submitting = true;
      if (this.challenge.id && this.userCanAcceptChallenges && !!this.user.slug) {
        await followedState.fetchfollowedChallenges(this.user.slug);
        await acceptedState.acceptChallenge(this.challenge.id);
        await acceptedState.fetchAcceptedChallenges({
          params: {
            page: 1
          }
        });
        await challengesState.getChallengeById(this.challenge.id);
        await followedState.fetchfollowedChallenges(this.user.slug);
        this.onChallengeAccepted();
        this.buttonTrigger = true;
      }
    } catch (error) {
      this.displayError(error.message);
    } finally {
      this.submitting = false;
    }
  }

  async abort() {
    this.confirmAbortDialog = false;
    try {
      this.submitting = true;
      if (this.challenge.id && this.user.id) {
        await acceptedState.abortChallenge(this.challenge.id);
      }
      this.onChallengeAccepted();
    } catch (error) {
      this.displayError(error.message);
    } finally {
      this.submitting = false;
    }
  }

  goToCreateTeam() {
    teamsState.teamLoaded(null);
    this.$router.push({ name: 'challenge-new-team' });
  }

  displaySuccess(message: string) {
    this.snackbarVisibility = true;
    this.snackbarColor = 'green';
    this.snackbarText = message;
  }

  displayError(message: string) {
    this.snackbarVisibility = true;
    this.snackbarColor = 'red';
    this.snackbarText = message;
  }

  openProfilePage() {
    this.$router.push('/profile/config');
  }

  async onLoggedIn() {
    await acceptedState.fetchAcceptedChallenges({
      params: {
        page: 1
      }
    });
    await userState.fetchUser();
    this.onChallengeAccepted();
  }
}
